import {Component, OnInit, ViewChild, OnDestroy} from '@angular/core';
import {RegistriesService} from '../../service';
import {TableReactiveUrlController} from '@amlCore/tableReactive';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {AlertPanelComponent, AlertService} from '@amlCore/components';
import {DictInfo} from '../../model';
import {AccessJson} from '@amlCore/models';
import {CheckDictEnum, RegistriesAccessEnum} from '@amlCore/enums';
import {ResourceService, TableService, UserService, VisitedService} from '@amlCore/services';
import {Utils} from '@amlCore/utils';


@Component({
  selector: 'app-registry-mass-adr-info',
  templateUrl: './massAdrInfo.component.html'
})
export class MassAdrInfoComponent extends TableReactiveUrlController implements OnInit, OnDestroy {

  isShowVisited = true;
  loadCheckList = {};
  @ViewChild('alertObjCheck', {static: false}) alertObjToCheck: AlertPanelComponent;

  constructor(private readonly regSrv: RegistriesService,
              private readonly resourceSrv: ResourceService,
              private readonly userSrv: UserService,
              private readonly alertSrv: AlertService,
              protected readonly activatedRoute: ActivatedRoute,
              protected readonly visitedService: VisitedService,
              protected readonly tableService: TableService,
              protected readonly router: Router) {
    super(router, activatedRoute, visitedService, tableService, {pageSize: 20, sort: 'uploaded', dir: 'DESC'});
  }

  massAdrInfoEntries: Array<DictInfo> = [];
  access: AccessJson;

  ngOnInit() {
    this.access = this.userSrv.getAccess(RegistriesAccessEnum.QREF_MSLEAD);
    this.activatedRoute.queryParams.subscribe(data => {
      this.loadList(this.syncParams(data));
    });
  }

  onPageChange(params) {
    this.navigate(this.getParams(params));
  }

  loadList(params?: any) {
    const queryParams = this.getParams(params);
    this.resourceSrv.getMassAdrInfo(queryParams).subscribe(data => {
      this.massAdrInfoEntries = data.content;
      this.total = data.totalElements;
      this.scrollRun();
    });
  }

  /**
   * метод получения объекта плоского фильтра
   * @param data объект фильтра с полями
   */
  public getFilterObject(data) {
    const filter = this.tableService.getFilterSubject(data);
    return this.getFilterPlanObject(filter);
  }

  edit(msAdr: DictInfo) {
    this.tableService.saveScrollPosition(this.commonKeyStore);
    this.router.navigate(['registries/massAdrSubject', msAdr.id]);
  }

  onSearch() {
    const queryParams = this.getSearchPage(this.filter);
    queryParams["sort"] = "region";
    queryParams["dir"] = "ASC";
    this.tableService.saveScrollPosition(this.commonKeyStore);
    this.router.navigate(['registries/massAdrInfoAll'], {
      queryParams: {q: Utils.encodeJSONBase64(queryParams)} as Params
    });
  }

  remove(confirm, massAdr: DictInfo) {
    this.alertSrv.clear();
    this.regSrv.removeFile('/api/v1/qref/msadr/remove', {id: massAdr.id}).subscribe(data => {
      this.alertSrv.success(`Запись ${massAdr.name} удалена!`);
      this.loadList();
    });
  }

  /**
   * Проверка по факторам риска
   * @param item - элемент проверки
   */
  checkRiskFactor(item: DictInfo) {
    this.regSrv.doCheckRiskFactor(item, CheckDictEnum.MS_ADR_INFO, this.loadCheckList, this.alertObjToCheck);
  }

  ngOnDestroy() {
    this.checkScrollOptions();
  }

}
